import { Link } from "react-router";
import { useT, useTurl } from "~/util/Lang";
import css from "./Summon.module.css"
import clsx from "clsx";
import { ItemLink } from "../item/ItemLink";

type SummonLevels = {
  npcName: string;
  level: number | null;
}

type ActiveNpc = {
  npcName: string
  type: string;
  soulshotCount: number;
  spiritshotCount: number;
}



export function Summon(props: { summonLevels: SummonLevels[]; activeNpc: ActiveNpc; }) {
  const t = useT()
  const turl = useTurl();

  const soulshot = { itemName: "beast_soul_shot", name: t({ en: "Beast Soulshot", ru: "Заряд Души Зверя" }), icon: "etc_beast_soul_shot_i00" };
  const spiritshot = { itemName: "beast_spirit_shot", name: t({ en: "Beast Spiritshot", ru: "Заряд Духа Зверя" }), icon: "etc_beast_spirit_shot_i00" };

  return <div className='columns'>
    <div className="column">
      {props.activeNpc.type == "summon" && <div className={css.summon}>
        <div className={css.summonTitle}>{t({ en: "Summon Levels", ru: "Уровни Саммона" })}</div>
        <div className={css.summonLevels}>{props.summonLevels.map((sLevel, index) => <Link key={index} to={turl(`/npcs/${sLevel.npcName}`)} className={clsx({ [css.summonLevel]: true, [css.summonLevelActive]: sLevel.npcName === props.activeNpc.npcName })}>{sLevel.level}</Link>)}</div>
      </div>}
      {props.activeNpc.soulshotCount > 0 && props.activeNpc.spiritshotCount > 0 && <div>
        <div className={css.summonTitle}>{t({ en: "Using shots", ru: "Использование шотов" })}</div>
        <div><ItemLink item={soulshot} count={props.activeNpc.soulshotCount} /></div>
        <div><ItemLink item={spiritshot} count={props.activeNpc.spiritshotCount} /></div>
      </div>}
    </div>
    <div className="column is-half"></div>
  </div>
}